import { BaseService, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { Post } from "@kiddocare-platform/portal-common/communication";

export class CommunicationMessagingService extends BaseService {

	public async SearchInstanceMessage(params: { currentPage: number, pageSize: number, idAccountPatient?: bigint, idAccountPediatrician?: bigint }): Promise<ResponseMessage<Array<Post>>> {
		try {
			const response = await this.AxiosInstance.post('/parent/messagings/searchInstancePost', params);
			return response.data;
		}
		catch (error: any) {
			this.log.error("SearchInstanceMessage", error.stack, JSON.stringify(error));
			throw error;
		}
	}

	public async GetInstanceMessageByTicket(ticket: string): Promise<ResponseMessage<{ post: Post }>> {
		try {
			const response = await this.AxiosInstance.get(`/parent/messagings/getInstancePostByTicket/${ticket}`);
			return response.data;
		}
		catch (error: any) {
			this.log.error("GetInstanceMessageByTicket", error.stack, JSON.stringify(error));
			throw error;
		}
	}
}
